import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import {getAdminEmpresa, getGestorEmpresa, getGestorOperacoes, getOperadorEmpresa, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import alterarExibicaoDetalhamentoRota from '../../actions/rota/alterarExibicaoDetalhamentoRota';
import selecionarRota from '../../actions/rota/selecionarRota';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarConexao from '../../actions/rota/selecionarConexao';
import buscarPrecosRota from '../../actions/preco/buscarPrecosRota';
import Conexao from './Conexao';
import buscarUltimosHistoricosRota from '../../actions/rota/buscarUltimosHisotirocosRota';
import iconAudoria from  '../../img/auditoria.png';

export class Rota extends React.Component {
    selecionarRota() {
        this.props.selecionarOrigem(this.props.rota.cidadeOrigem);
        this.props.selecionarDestino(this.props.rota.cidadeDestino);
        this.props.selecionarRota(this.props.rota);
    }

    selecionarConexao() {
        this.props.selecionarOrigem(null);
        this.props.selecionarDestino(null);
        this.props.selecionarConexao(null);
        this.props.selecionarRota(this.props.rota)
    }

    render() {
        return (
            <React.Fragment>
                <div className="geral">
                    <div className="resumo">
                        <div className="row">
                            <div title='Conexões' className="col-lg-1 col-xl-1"
                                 onClick={() => this.props.alterarExibicaoDetalhamentoRota(this.props.rota)}
                                 style={{cursor: 'pointer'}}>
                                {this.props.rota.exibirDetalhe ?
                                    <i className="material-icons" style={{cursor: 'pointer'}}>
                                        &#xe5c7;
                                    </i> : <i className="material-icons" style={{cursor: 'pointer'}}>
                                        &#xe5c5;
                                    </i>}
                            </div>
                            <div className="col-lg-1 col-xl-1">
                                <span 
                                    className="titulo-mobile">ID:&nbsp;</span>{this.props.rota.id ? this.props.rota.id : ''}
                            </div>
                            <div className="col-lg-1 col-xl-1">
                                <span
                                    className="titulo-mobile">Prefixo:&nbsp;</span>{this.props.rota.prefixo ? this.props.rota.prefixo : 'Não informado'}
                            </div>
                            <div className="col-lg-2 col-xl-2">
                                <span
                                    className="titulo-mobile">Cidade origem:&nbsp;</span>{this.props.rota.cidadeOrigem ? this.props.rota.cidadeOrigem.nomeComUf : ''}
                            </div>
                            <div className="col-lg-2 col-xl-2">
                                <span
                                    className="titulo-mobile">Cidade destino:&nbsp;</span>{this.props.rota.cidadeDestino? this.props.rota.cidadeDestino.nomeComUf : ''}
                            </div>
                            <div className="col-lg-2 col-xl-2">
                                <span
                                    className="titulo-mobile">Delimitação:&nbsp;</span>{this.props.rota.delimitacao ? this.props.rota.delimitacao : 'Não informado'}
                            </div>
                            <div className="col-lg-3 col-xl-3">
                                <Autorizacao
                                    perfisPermitidos={[PERFIL_ADMIN,
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getGestorOperacoes(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                    <div className="acoes">
                                        <div className="botoes">
                                            <button type="button" className="btn btn-excluir"
                                                    data-toggle="modal"
                                                    data-target="#modalConfirmacaoExclusaoRota"
                                                    title='Excluir'
                                                    onClick={() => this.props.selecionarRota(this.props.rota)}>
                                                <i className="material-icons nav-icon">&#xe872;</i>
                                            </button>
                                            <button type="button" className="btn btn-editar ml-2"
                                                    data-toggle="modal"
                                                    title='Editar'
                                                    data-target="#modalCadastrarRota"
                                                    onClick={() => this.selecionarRota(this.props.rota)}>
                                                <i className="material-icons nav-icon">&#xe150;</i>
                                            </button>
                                            <button type="button" className="btn ml-2"
                                                    data-toggle="modal"
                                                    title='Criar rota de retorno'
                                                    data-target="#modalConfirmacaoCadastroRotaRetorno"
                                                    onClick={() => this.props.selecionarRota(this.props.rota)}>
                                                <i className="material-icons nav-icon">&#xe31b;</i>
                                            </button>
                                            <button type="button" className="btn ml-2"
                                                    data-toggle="modal"
                                                    title='Visualizar trechos'
                                                    data-target="#modalTrechos"
                                                    onClick={() => this.props.selecionarRota(this.props.rota)}>
                                                <i className="material-icons nav-icon">&#xe8d4;</i>
                                            </button>
                                            <button type="button" className="btn ml-2"
                                                    data-toggle="modal"
                                                    title='Criar conexão'
                                                    data-target="#modalCadastroConexao"
                                                    onClick={() => this.selecionarConexao()}>
                                                <i className="material-icons nav-icon">&#xe0b3;</i>
                                            </button>
                                            <button type="button" className="btn ml-2"
                                                    data-toggle="modal"
                                                    title='Relação de valores da rota'
                                                    data-target="#modalPrecosRota"
                                                    onClick={() => {
                                                        this.props.buscarPrecosRota(this.props.empresaSelecionada.id, this.props.rota.id)
                                                        this.props.selecionarRota(this.props.rota)
                                                    }}>
                                                <i className="material-icons nav-icon">&#xe263;</i>
                                            </button>
                                            <button type="button" className="btn ml-2"
                                                    data-toggle="modal"
                                                    title='Buscar últimos Históricos Rota'
                                                    data-target="#modalHistoricoRota"
                                                    onClick={() => {
                                                        this.props.selecionarRota(this.props.rota)
                                                        this.props.buscarUltimosHistoricosRota(this.props.rota.id, this.props.empresaSelecionada.id)
                                                    }}>                                                
                                                <img src={iconAudoria} alt="Históricos Rota" />
                                            </button>
                                        </div>
                                    </div>
                                </Autorizacao>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.rota.exibirDetalhe ?
                    <div className="card-body cinza-zebrado">
                        <div className='text-center mb-2' style={{marginTop: '-6px'}}><strong>Conexões:</strong></div>
                        {this.props.rota.conexoes && this.props.rota.conexoes.length
                            ? this.props.rota.conexoes.map((conexao) => <Conexao rota={this.props.rota} key={conexao.id}
                                                                                 conexao={conexao} preencherCidades={this.props.preencherCidades} />) : 'Rota não possui conexões cadastradas'}
                    </div> : ''}

            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada
    });

export default connect(mapStateToProps, {
    changeFieldValue,
    alterarExibicaoDetalhamentoRota,
    selecionarRota,
    selecionarOrigem,
    selecionarDestino,
    selecionarConexao,
    buscarPrecosRota,
    buscarUltimosHistoricosRota
})(reduxForm({
    form: 'formularioCadastroRota'
})(Rota))
